if(!customElements.get('adult-product-link')) {
  class AdultProductLink extends ModalOpener {
    constructor() {
      super();
      this.button = this.querySelector('.product__adult-product-link__link');
      if (!this.button || !this.button.dataset.productUrl) return;

      const url = new URL(this.button.dataset.productUrl.startsWith('/') ? window.location.origin + this.button.dataset.productUrl : this.button.dataset.productUrl);
      const params = url.searchParams;
      params.set('view', this.dataset.template || 'modal-quick-add');
      url.search = params.toString();

      this.url = url;
      this.bindTriggerRestockModal = this.triggerRestockModal.bind(this);

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.openModal(this.button);
      });
    }

    openModal(trigger) {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(trigger);
      else this.renderModal(trigger)
    }

    renderModal(trigger) {
      if (!this.url) return;
      trigger.setAttribute('aria-disabled', true);
      this.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');
      fetch(this.url)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productQuickAdd = responseHTML.querySelector('.section--product-modal-quick-add');

          this.removeDOMElements();
          this.preventDuplicatedIDs();
          setTimeout(() => {
            this.setHTML(this.productQuickAdd);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            this.preventVariantURLSwitching();
          })

        })
        .finally(() => {
          setTimeout(() => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) {
              modal.show(trigger);
              requestAnimationFrame(() => {
                modal.querySelectorAll('component-slider').forEach(slider => {
                  if (typeof slider.setUpSlider === 'function') slider.setUpSlider();
                });
              });
            }
            trigger.removeAttribute('aria-disabled');
            this.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            this.productInfo = this.querySelector('product-info');
            this.restockButton = this.querySelector('.restock-custom-button');
            this.restockJson = this.querySelector('.restock-json');
            if (this.restockJson) this.restockProductInfo = JSON.parse(this.restockJson.textContent);
            if (this.restockButton) this.restockButton.addEventListener('click', this.bindTriggerRestockModal);

            if (typeof window._RestockRocket == 'undefined' && this.restockButton) this.restockButton.classList.add('hidden');
          }, 300)
        });
    }

    setHTML(html) {
      this.modals = this.productQuickAdd.querySelectorAll('quick-add-modal, .quick-add-modal--modal')
      const scripts = Array.from(html.querySelectorAll('script'))
      this.modals.forEach(element => {
        document.body.appendChild(element);
      });


      scripts.filter(tag => !tag.classList.contains('klaviyo-skip-script')).forEach(scriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(scriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(scriptTag.innerHTML));
        document.body.appendChild(newScriptTag);
      })
    }

    removeDOMElements() {
      const quickAddModal = this.productQuickAdd.querySelector('quick-add-modal');
      if (quickAddModal) {
        quickAddModal.classList.remove('quick-add-modal-section');
      }
    }

    preventVariantURLSwitching() {
      const variantPicker = this.productQuickAdd.querySelector('variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    preventDuplicatedIDs() {
      const quickAddModal = this.productQuickAdd.querySelector('quick-add-modal');
      if (!quickAddModal) return;

      const sectionId = quickAddModal.dataset.section;
      this.productQuickAdd.innerHTML = this.productQuickAdd.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      this.productQuickAdd.querySelectorAll('variant-selects, product-info').forEach((element) => {
        if (sectionId != undefined)
          element.dataset.originalSection = sectionId;
      });
    }

    triggerRestockModal(event) {
      if (typeof window._RestockRocket == 'undefined') return;

      window._RestockRocket.openModal(this.restockProductInfo, +this.productInfo.dataset.selectedVariant);
    }
  }

  customElements.define('adult-product-link', AdultProductLink)
}